import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import BookingForm from "@/components/booking/BookingForm";

/** Standalone export booking form — opened from shipment list in a new tab. */
const ExportBookingFormPage = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const bookingId = Number(id) || 0;

    const handlePrint = (shipmentOrId) => {
        const printId =
            typeof shipmentOrId === "object"
                ? shipmentOrId?.id
                : shipmentOrId ?? bookingId;
        if (!printId) return;
        window.open(
            `${window.location.origin}/booking/print/${btoa(String(printId))}`,
            "_blank",
            "noopener,noreferrer",
        );
    };

    return (
        <div className="h-full p-3 sm:p-4 lg:p-6">
            <BookingForm
                bookingData={bookingId}
                onBack={() => navigate("/booking")}
                onPrint={handlePrint}
            />
        </div>
    );
};

export default ExportBookingFormPage;
